import React from 'react';
import ReactDOM from 'react-dom/client';
import './sass/style.scss';
import Main from './components/main/Main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Main />
);

